import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Login = () => {
    const [mode, setMode] = useState('login'); // 'login' or 'register'
    const [sendingCode, setSendingCode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [countdown, setCountdown] = useState(0); // 验证码倒计时

    // 倒计时效果
    useEffect(() => {
        if (countdown <= 0) return;
        const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown]);
    
    // Login state
    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [loginPhone, setLoginPhone] = useState('');
    const [loginPhonePassword, setLoginPhonePassword] = useState('');
    
    // Register state
    const [registerEmail, setRegisterEmail] = useState('');
    const [registerCode, setRegisterCode] = useState('');
    const [registerName, setRegisterName] = useState('');
    const [registerPassword, setRegisterPassword] = useState('');
    const [registerPhone, setRegisterPhone] = useState('');
    const [registerPhoneCode, setRegisterPhoneCode] = useState('');
    const [registerPhonePassword, setRegisterPhonePassword] = useState('');
    const [authType, setAuthType] = useState('email'); // 'email' or 'phone'

    const handleShowRegister = () => setMode('register');

    const handleEmailLogin = async () => {
        if (!loginEmail || !loginPassword) {
            alert('请输入邮箱和密码');
            return;
        }
        setLoading(true);
        try {
            const res = await fetch('/auth/login/email', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: loginEmail, password: loginPassword }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                alert('登录成功！');
                window.location.href = '/';
            } else {
                alert('登录失败：' + (data.message || '邮箱或密码错误'));
            }
        } catch (err) {
            console.error('email login error', err);
            alert('网络错误，请重试');
        }
        setLoading(false);
    };

    const handlePhoneLogin = async () => {
        if (!loginPhone || !loginPhonePassword) {
            alert('请输入手机号和密码');
            return;
        }
        setLoading(true);
        try {
            const res = await fetch('/auth/login/phone', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone: loginPhone, password: loginPhonePassword }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                alert('登录成功！');
                window.location.href = '/';
            } else {
                alert('登录失败：' + (data.message || '手机号或密码错误'));
            }
        } catch (err) {
            console.error('phone login error', err);
            alert('网络错误，请重试');
        }
        setLoading(false);
    };

    const sendEmailCode = async () => {
        if (!registerEmail || !registerEmail.includes('@')) {
            alert('请输入有效的邮箱');
            return;
        }
        setSendingCode(true);
        try {
            const res = await fetch('/auth/register/send-email-code', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: registerEmail }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                setCountdown(60);
                alert('验证码已发送到您的邮箱，请查收 / Verification code sent to your email');
            } else {
                alert(data.message || '发送失败');
            }
        } catch (err) {
            console.error('send-email-code error', err);
            alert('网络错误，发送失败');
        }
        setSendingCode(false);
    };

    const sendPhoneCode = async () => {
        if (!registerPhone || registerPhone.length < 6) {
            alert('请输入有效的手机号');
            return;
        }
        setSendingCode(true);
        try {
            const res = await fetch('/auth/register/send-phone-code', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone: registerPhone }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                setCountdown(60);
                alert('验证码已发送 / Verification code sent');
            } else {
                alert(data.message || '发送失败');
            }
        } catch (err) {
            console.error('send-phone-code error', err);
            alert('网络错误，发送失败');
        }
        setSendingCode(false);
    };

    const handleSubmitRegister = async () => {
        if (!registerEmail || !registerCode || !registerPassword) {
            alert('请填写邮箱/验证码/密码');
            return;
        }
        try {
            const res = await fetch('/auth/register/email', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: registerEmail, code: registerCode, password: registerPassword, name: registerName }),
            });
            const data = await res.json();
            console.log('register result:', data);
            if (data.status === 'success') {
                alert('注册成功！页面将刷新以反映登录状态。');
                window.location.reload();
            } else {
                alert('注册失败：' + (data.message || JSON.stringify(data)));
            }
        } catch (e) {
            console.error('register submit error', e);
            alert('注册请求失败，请检查网络或后端日志');
        }
    };

    const handleSubmitPhoneRegister = async () => {
        if (!registerPhone || !registerPhoneCode || !registerPhonePassword) {
            alert('请填写手机号/验证码/密码');
            return;
        }
        try {
            const res = await fetch('/auth/register/phone', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone: registerPhone, code: registerPhoneCode, password: registerPhonePassword, name: registerName }),
            });
            const data = await res.json();
            console.log('register-phone result:', data);
            if (data.status === 'success') {
                alert('注册成功！页面将刷新以反映登录状态。');
                window.location.reload();
            } else {
                alert('注册失败：' + (data.message || JSON.stringify(data)));
            }
        } catch (e) {
            console.error('register phone submit error', e);
            alert('注册请求失败，请检查网络或后端日志');
        }
    };

    const handleError = (errorResponse) => {
        console.log('Google login error', errorResponse);
    };

    const handleCredentialResponse = (credentialResponse) => {
        console.log('Google credential response:', credentialResponse);
        // 先确保 session cookie 存在
        fetch('/api/user/info', { credentials: 'include' })
            .then(() => {
                return fetch('/google-auth/credential', {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(credentialResponse),
                });
            })
            .then((res) => res.json())
            .then((data) => {
                console.log('/google-auth/credential ->', data);
                if (data.status === 'success') {
                    window.location.href = '/';
                } else {
                    alert('Google 登录失败：' + (data.message || '未知错误'));
                }
            })
            .catch((err) => {
                console.error('Google login error:', err);
                alert('Google 登录异常，请重试');
            });
    };

    // 统一的输入框样式 - 浅灰色背景 + 深色文字，更清晰
    const textFieldSx = {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            '& fieldset': { borderColor: '#d0d0d0' },
            '&:hover fieldset': { borderColor: '#1976d2' },
            '&.Mui-focused fieldset': { borderColor: '#1976d2' },
        },
        '& input': { color: '#222' },
        '& .MuiInputLabel-root': { color: '#666' },
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            style={{
                backgroundImage: 'url(/login_bg.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center bottom',
                backgroundAttachment: 'fixed',
                position: 'relative',
            }}
        >
            <Box
                style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 1,
                }}
            />

            <Box
                sx={{
                    zIndex: 2,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    width: '420px',
                    p: 4,
                    textAlign: 'center',
                    borderRadius: '16px',
                    backgroundColor: 'rgba(255, 255, 255, 0.92)',
                    backdropFilter: 'blur(12px)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
                }}
            >
                <img src="https://portali.hku.hk/cas-login-2022/hku-logo.png" alt="HKU Logo" style={{ width: '320px', marginBottom: '12px' }} />
                <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 500, letterSpacing: 2 }}>
                    BEE IOT DASHBOARD
                </Typography>

                <Box display="flex" justifyContent="center" width="100%" marginTop="12px">
                    <GoogleOAuthProvider clientId="717001847191-93u6u3liuhlp2jo4bulrpbd2tohn2tjd.apps.googleusercontent.com">
                        <GoogleLogin onSuccess={handleCredentialResponse} onError={handleError} useOneTap={false} />
                    </GoogleOAuthProvider>
                </Box>

                <Box sx={{ mt: 2 }}>
                    <Button
                        fullWidth variant="contained"
                        onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
                        disabled={loading || sendingCode}
                        sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            py: 1.2,
                            backgroundColor: '#1a5276',
                            '&:hover': { backgroundColor: '#154360' },
                        }}
                    >
                        {mode === 'login' ? '没有账户？注册 / No account? Register' : '已有账户？登录 / HAVE ACCOUNT? LOGIN'}
                    </Button>
                </Box>

                {mode === 'login' && (
                    <Box sx={{ mt: 3, textAlign: 'left' }}>
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', color: '#333' }}>
                            登录 / Login
                        </Typography>

                        <Box sx={{ mb: 2, p: 2, borderRadius: '10px', bgcolor: 'rgba(25, 118, 210, 0.04)', border: '1px solid #e3e8ef' }}>
                            <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 600 }}>邮箱登录 / Email Login</Typography>
                            <TextField label="邮箱 / Email" fullWidth margin="dense" size="small" value={loginEmail}
                                onChange={(e) => setLoginEmail(e.target.value)}
                                sx={textFieldSx} disabled={loading}
                            />
                            <TextField label="密码 / Password" type="password" fullWidth margin="dense" size="small" value={loginPassword}
                                onChange={(e) => setLoginPassword(e.target.value)}
                                sx={textFieldSx} disabled={loading}
                            />
                            <Button fullWidth variant="contained" onClick={handleEmailLogin}
                                sx={{ mt: 1, borderRadius: '8px', textTransform: 'none', backgroundColor: '#1976d2' }} disabled={loading}>
                                {loading ? '登录中...' : '邮箱登录 / Email Login'}
                            </Button>
                        </Box>

                        <Box sx={{ mb: 2, p: 2, borderRadius: '10px', bgcolor: 'rgba(25, 118, 210, 0.04)', border: '1px solid #e3e8ef' }}>
                            <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 600 }}>手机号登录 / Phone Login</Typography>
                            <TextField label="手机号 / Phone" fullWidth margin="dense" size="small" value={loginPhone}
                                onChange={(e) => setLoginPhone(e.target.value)}
                                sx={textFieldSx} placeholder="+852 / +86 ..."
                                disabled={loading}
                            />
                            <TextField label="密码 / Password" type="password" fullWidth margin="dense" size="small" value={loginPhonePassword}
                                onChange={(e) => setLoginPhonePassword(e.target.value)}
                                sx={textFieldSx} disabled={loading}
                            />
                            <Button fullWidth variant="contained" onClick={handlePhoneLogin}
                                sx={{ mt: 1, borderRadius: '8px', textTransform: 'none', backgroundColor: '#1976d2' }} disabled={loading}>
                                {loading ? '登录中...' : '手机号登录 / Phone Login'}
                            </Button>
                        </Box>
                    </Box>
                )}

                {mode === 'register' && (
                    <Box sx={{ mt: 3, textAlign: 'left' }}>
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', color: '#333' }}>
                            注册 / Register
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 2 }}>
                            <Button variant={authType === 'email' ? 'contained' : 'outlined'}
                                onClick={() => setAuthType('email')} disabled={loading || sendingCode}
                                sx={{ borderRadius: '8px', textTransform: 'none' }}>
                                邮箱注册 / EMAIL
                            </Button>
                            <Button variant={authType === 'phone' ? 'contained' : 'outlined'}
                                onClick={() => setAuthType('phone')} disabled={loading || sendingCode}
                                sx={{ borderRadius: '8px', textTransform: 'none' }}>
                                手机注册 / PHONE
                            </Button>
                        </Box>

                        {authType === 'email' && (
                            <Box sx={{ p: 2, borderRadius: '10px', bgcolor: 'rgba(25, 118, 210, 0.04)', border: '1px solid #e3e8ef' }}>
                                <TextField label="邮箱 / Email" fullWidth margin="dense" size="small" value={registerEmail}
                                    onChange={(e) => setRegisterEmail(e.target.value)}
                                    sx={textFieldSx} />

                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 1 }}>
                                    <Button variant="outlined" onClick={sendEmailCode} size="small"
                                        disabled={sendingCode || countdown > 0}
                                        sx={{ borderRadius: '8px', textTransform: 'none', whiteSpace: 'nowrap' }}>
                                        {countdown > 0 ? `${countdown}s` : (sendingCode ? '发送中...' : '发送验证码 / Send Code')}
                                    </Button>
                                    <Typography variant="body2" sx={{ color: '#888', fontSize: '12px' }}>
                                        验证码将发送至邮箱
                                    </Typography>
                                </Box>

                                <TextField label="验证码 / Code" fullWidth margin="dense" size="small" value={registerCode}
                                    onChange={(e) => setRegisterCode(e.target.value)}
                                    sx={textFieldSx} />
                                <TextField label="姓名 / Name" fullWidth margin="dense" size="small" value={registerName}
                                    onChange={(e) => setRegisterName(e.target.value)}
                                    sx={textFieldSx} />
                                <TextField label="密码 / Password (≥8位,含字母+数字)" type="password" fullWidth margin="dense" size="small"
                                    value={registerPassword} onChange={(e) => setRegisterPassword(e.target.value)}
                                    sx={textFieldSx} />

                                <Box sx={{ mt: 1.5 }}>
                                    <Button fullWidth variant="contained" onClick={handleSubmitRegister} disabled={loading}
                                        sx={{ borderRadius: '8px', textTransform: 'none', py: 1.2, backgroundColor: '#2e7d32', '&:hover': { backgroundColor: '#1b5e20' } }}>
                                        {loading ? '提交中...' : '提交注册 / SUBMIT'}
                                    </Button>
                                </Box>
                            </Box>
                        )}

                        {authType === 'phone' && (
                            <Box sx={{ p: 2, borderRadius: '10px', bgcolor: 'rgba(25, 118, 210, 0.04)', border: '1px solid #e3e8ef' }}>
                                <TextField label="手机号 / Phone" fullWidth margin="dense" size="small" value={registerPhone}
                                    onChange={(e) => setRegisterPhone(e.target.value)}
                                    sx={textFieldSx} placeholder="+852 / +86 ..."
                                />

                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 1 }}>
                                    <Button variant="outlined" onClick={sendPhoneCode} size="small"
                                        disabled={sendingCode || countdown > 0}
                                        sx={{ borderRadius: '8px', textTransform: 'none', whiteSpace: 'nowrap' }}>
                                        {countdown > 0 ? `${countdown}s` : (sendingCode ? '发送中...' : '发送验证码 / Send Code')}
                                    </Button>
                                    <Typography variant="body2" sx={{ color: '#888', fontSize: '12px' }}>
                                        验证码将发送至手机
                                    </Typography>
                                </Box>

                                <TextField label="验证码 / Code" fullWidth margin="dense" size="small" value={registerPhoneCode}
                                    onChange={(e) => setRegisterPhoneCode(e.target.value)}
                                    sx={textFieldSx} />
                                <TextField label="姓名 / Name" fullWidth margin="dense" size="small" value={registerName}
                                    onChange={(e) => setRegisterName(e.target.value)}
                                    sx={textFieldSx} />
                                <TextField label="密码 / Password (≥8位,含字母+数字)" type="password" fullWidth margin="dense" size="small"
                                    value={registerPhonePassword} onChange={(e) => setRegisterPhonePassword(e.target.value)}
                                    sx={textFieldSx} />

                                <Box sx={{ mt: 1.5 }}>
                                    <Button fullWidth variant="contained" onClick={handleSubmitPhoneRegister} disabled={loading}
                                        sx={{ borderRadius: '8px', textTransform: 'none', py: 1.2, backgroundColor: '#2e7d32', '&:hover': { backgroundColor: '#1b5e20' } }}>
                                        {loading ? '提交中...' : '提交注册 / SUBMIT'}
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Login;